/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
  DatePicker,
  Tabs,
  Tooltip,
} from 'antd';
import { QuestionCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { formatReceivedValues } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import currencyFormatter from 'utils/currencyFormatter';
import CurrencyInput from 'components/CurrencyInput';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import makeMessager from 'utils/complexFormsMessages';
import { getModelPermission } from 'utils/permission';
import Select from 'components/Select';
import {
  getEstadosGlobales,
} from 'api/catalogos/index';
import {
  getTabuladoresNominales,
  postTabuladorNominal,
  deleteTabuladorNominal,
  patchTabuladorNominal,
  getTabuladorNominal,
} from 'api/nominas/tabuladores/tabuladoresNominales';
import {
  getPuestos,
} from 'api/estructuraOrganizacional/puestos';
import {
  getTabuladoresGenerales,
} from 'api/nominas/tabuladores/tabuladoresGenerales';
import {
  getCategorias,
} from 'api/catalogos/plazas';
import {
  getTiposDeEmpleados,
} from 'api/catalogos/tiposDeEmpleados';
import {
  getNivelesSalarialesTabulares,
} from 'api/nominas/catalogos/nivelesSalarialesTabulares';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
  FLOAT_NUMER_PATTERN,
} from 'utils/patterns';
import TabuladorNominalDeduccion, { tabuladorNominalDeduccionPermission } from './TabuladoresNominalesDeducciones';
import TabuladorNominalPercepcion, { tabuladorNominalPercepcionPermission } from './TabuladoresNominalesPercepciones';
import {
  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
} from '../../../utils/constants';

const { TabPane } = Tabs;

export const tabuladorNominalPermission = {
  permissionModel: 'tabuladornominal',
  catalogsModels: [],
  tabsModels: [],
};

const complexForms = [];
const baseURI = 'nominas/tabuladores-nominales';

const TabuladorNominal = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [estados, setEstados] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('percepciones');
  const [tabuladores, setTabuladores] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [mutable, setMutable] = useState(true);
  const [categoria, setCategoria] = useState();
  const [desdeSueldoDiario, setDesdeSueldoDiario] = useState();
  const [hastaSueldoDiario, setHastaSueldoDiario] = useState();
  const [tiposEmpleados, setTiposEmpleados] = useState([]);
  const [tipoEmpleado, setTipoEmpleado] = useState();
  const [nivelesSalarialesTabulares, setNivelesSalarialesTabulares] = useState([]);
  const [nivelSalarialTabular, setNivelSalarialTabular] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [disableSave, setDisableSave] = useState(false);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        puestoTE: e?.puesto,
        puesto_categoria: e?.puesto,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const basicKeys = [
    'percepciones',
    'deducciones',
  ];

  const formInstances = [
    form,
  ];

  const getPermissionDeduccion = getModelPermission(
    tabuladorNominalDeduccionPermission.permissionModel,
    tabuladorNominalDeduccionPermission.catalogsModels,
    tabuladorNominalDeduccionPermission.tabsModels,
    false,
  );

  const getPermissionPercepcion = getModelPermission(
    tabuladorNominalPercepcionPermission.permissionModel,
    tabuladorNominalPercepcionPermission.catalogsModels,
    tabuladorNominalPercepcionPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    setLoading(true);
    const _data = await getTabuladoresNominales();
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _puestos,
        _tabuladores,
        _categorias,
        _tiposEmpleados,
        _nivelesSalarialesTabulares,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPuestos(),
        getTabuladoresGenerales({ estados_globales: ESTATUS_AUTORIZADO }),
        getCategorias(),
        getTiposDeEmpleados(),
        getNivelesSalarialesTabulares(),
        getTabuladoresNominales(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setPuestos(_puestos);
        setTabuladores(_tabuladores);
        setCategorias(_categorias);
        setTiposEmpleados(_tiposEmpleados);
        setNivelesSalarialesTabulares(_nivelesSalarialesTabulares);
        setData(formatReceivedClone(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setEstatusAutorizado(false);
    setEstatusInactivo(false);
    setDisableSave(false);
    setSelectedRowKeys([]);
    setVisible(false);
    setMutable(true);
    form.resetFields();
    setCategoria();
    setTipoEmpleado();
    setNivelSalarialTabular();
    setDesdeSueldoDiario();
    setHastaSueldoDiario();
  };

  const isDisabled = (rowEstatus) => {
    if (rowEstatus !== ESTATUS_ACTIVO) {
      setDisableSave(true);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _tabulador = await getTabuladorNominal(match.id);
    if (_tabulador?.estados_globales === ESTATUS_ACTIVO || _tabulador?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO || estado?.id === ESTATUS_ACTIVO));
    }
    if (_tabulador?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    if (_tabulador?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    setTimeout(() => {
      if (_tabulador) {
        form.resetFields();
        setTimeout(() => {
          isDisabled(_tabulador?.estados_globales);
          form.setFieldsValue(formatReceivedClone(_tabulador));
          const _tabuladorGeneral = tabuladores.find((e) => e.id === _tabulador?.tabulador_general);
          const _puesto = puestos.find((e) => e.id === form.getFieldValue('puesto'));
          setVisible(true);
          setCategoria(categorias.find((e) => e.id === _puesto?.categoria)?.nombre);
          setDesdeSueldoDiario(tabuladores.find((e) => e.id === _tabulador?.tabulador_general)?.sueldo_diario_desde);
          setHastaSueldoDiario(tabuladores.find((e) => e.id === _tabulador?.tabulador_general)?.sueldo_diario_hasta);
          setTipoEmpleado(tiposEmpleados.find((e) => e.id === _puesto?.tipo_empleado)?.descripcion);
          setNivelSalarialTabular(`${nivelesSalarialesTabulares.find((e) => e.id === _tabuladorGeneral?.nivel_salarial_tabular)?.clave} - ${currencyFormatter(nivelesSalarialesTabulares.find((e) => e.id === _tabuladorGeneral?.nivel_salarial_tabular)?.sueldo_diario)}`);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchTabuladorNominal(key, values) : postTabuladorNominal(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteTabuladorNominal(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Tabulador Nominal',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto',
      key: 'puesto',
      width: 200,
      render: (val) => puestos.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Categoría',
      dataIndex: 'puesto_categoria',
      key: 'puesto_categoria',
      width: 200,
      // eslint-disable-next-line max-len
      render: (val) => categorias.find((e) => e.id === (puestos.find((a) => a.id === val)?.categoria))?.nombre,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'puestoTE',
      key: 'puestoTE',
      width: 200,
      // eslint-disable-next-line max-len
      render: (val) => tiposEmpleados.find((e) => e.id === (puestos.find((a) => a.id === val)?.tipo_empleado))?.descripcion,
    },
    {
      titleText: 'Vigencia Inicial',
      dataIndex: 'vigencia_inicial',
      key: 'vigencia_inicial',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const showMsg = makeMessager(setCurrentTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
    vigencia_inicial: [
      { required: true },
      {
        validator: async () => {
          const { vigencia_inicial, vigencia_final } = form.getFieldsValue();
          if (vigencia_inicial && vigencia_final
            && vigencia_inicial.diff(vigencia_final, 'days') >= 0) {
            throw new Error('Este campo debe ser menor que la Vigencia Final');
          }
        },
      },
    ],
    vigencia_final: [
      { required: false },
      {
        validator: async () => {
          const { vigencia_inicial, vigencia_final } = form.getFieldsValue();
          if (vigencia_inicial && vigencia_final
            && vigencia_final.diff(vigencia_inicial, 'days') <= 0) {
            throw new Error('Este campo debe ser mayor que la Vigencia Inicial');
          }
        },
      },
    ],
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchTabuladorNominal(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            allowImport
            baseURI={baseURI}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
            }
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'tabuladornominal', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
            ]}
            permission={permission}
            allowExportPDF={false}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Tabulador Nominal`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableSave}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave"
                    rules={rules.clave}
                    label="Clave"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="nombre"
                    label={(
                      <div style={{ display: 'flex' }}>
                        <span>Tabulador Nominal</span>
                        <Tooltip title="Asignar un nombre al Tabulador Nominal para identificarlo, se sugiere el nombre del Puesto." placement="right">
                          <QuestionCircleOutlined style={{ marginLeft: '5px', marginTop: '5px' }} />
                        </Tooltip>
                      </div>
                    )}
                    rules={rules.required}
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tabulador_general"
                    label="Tabulador General"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      labelProp="nombre"
                      keyProp="clave"
                      keyLabelRender
                      dataSource={tabuladores}
                      onChange={(value) => {
                        const _tabulador = tabuladores.find((e) => e.id === value);
                        const _puesto = puestos.find((e) => e.id === _tabulador?.puesto);
                        form.setFieldsValue({
                          puesto: _puesto?.id,
                        });
                        setDesdeSueldoDiario(_tabulador?.sueldo_diario_desde);
                        setHastaSueldoDiario(_tabulador?.sueldo_diario_hasta);
                        setCategoria(categorias.find((e) => e.id === _puesto?.categoria)?.nombre);
                        setTipoEmpleado(tiposEmpleados.find((e) => e.id === _puesto?.tipo_empleado)?.descripcion);
                        setNivelSalarialTabular(`${nivelesSalarialesTabulares.find((e) => e.id === _tabulador?.nivel_salarial_tabular)?.clave} - ${nivelesSalarialesTabulares.find((e) => e.id === _tabulador?.nivel_salarial_tabular)?.sueldo_diario}`);
                      }}
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="puesto"
                    label="Puesto"
                    hasFeedback
                  >
                    <Select
                      dataSource={puestos}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Categoría"
                  >
                    <Input
                      value={categoria}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Tipo de Empleado"
                  >
                    <Input
                      value={tipoEmpleado}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    label="Nivel Salarial Tabular"
                  >
                    <Input
                      value={nivelSalarialTabular}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    label="Desde Sueldo Diario Tabular"
                    value={desdeSueldoDiario}
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    label="Hasta Sueldo Diario Tabular"
                    value={hastaSueldoDiario}
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigencia_inicial"
                    label="Vigencia Inicial"
                    rules={rules.vigencia_inicial}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="vigencia_final"
                    label="Vigencia Final"
                    rules={rules.vigencia_final}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled={estatusInactivo || estatusAutorizado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                    rules={rules.estatus}
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={estadosFiltered}
                      disabled={!selectedRowKeys.length || estatusInactivo || estatusAutorizado}
                      onChange={(val) => {
                        if (val === ESTATUS_INACTIVO) {
                          setConfirmationVisibleEstatus(true);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {
                selectedRowKeys.length
                  ? (
                    <Tabs
                      activeKey={currentTabKey}
                      onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                      type="card"
                    >
                      <TabPane
                        tab="Percepciones"
                        key="percepciones"
                        forceRender
                      >
                        <TabuladorNominalPercepcion
                          permission={getPermissionPercepcion}
                          selected={selectedRowKeys[0]}
                          estatusInactivo={estatusInactivo || estatusAutorizado}
                        />
                      </TabPane>
                      <TabPane
                        tab="Deducciones"
                        key="deducciones"
                        forceRender
                      >
                        <TabuladorNominalDeduccion
                          permission={getPermissionDeduccion}
                          selected={selectedRowKeys[0]}
                          estatusInactivo={estatusInactivo || estatusAutorizado}
                        />
                      </TabPane>
                    </Tabs>
                  ) : null
              }
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Tabulador Nominal ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Tabulador Nominal ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          ConfirmInactive
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          contentTitle={`Inactivar el Tabulador Nominal ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default TabuladorNominal;
